export const genUniqueKey = () => {
    return new Date().toISOString();
};

export function shuffleArray(array) {
    // Lặp qua các phần tử của mảng từ cuối về đầu
    for (let i = array.length - 1; i > 0; i--) {
        // Chọn một chỉ số ngẫu nhiên từ 0 đến i
        const j = Math.floor(Math.random() * (i + 1));
        // Hoán đổi phần tử tại i với phần tử tại j
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export function splitText(input) {
    // Regex to match punctuation, whitespace, or sequences of other characters
    // eslint-disable-next-line
    const regex = /([.,;:()\/[\]{}]|\n)|(\s)|(.)/gu;

    // Initialize an array to hold the parts
    let result = [];

    // Use the regex to match all parts in the input string
    input.replace(regex, (match, punc, space, other) => {
        if (punc) {
            result.push(punc);
        } else if (space) {
            result.push(space);
        } else if (other) {
            if (
                result.length > 0 &&
                ![
                    ' ',
                    '.',
                    ',',
                    ';',
                    ':',
                    '(',
                    ')',
                    '/',
                    '[',
                    ']',
                    '{',
                    '}',
                    '\n',
                ].includes(result[result.length - 1])
            ) {
                result[result.length - 1] += other;
            } else {
                result.push(other);
            }
        }
    });

    return result;
}

export function processString(input, isToLowerCase) {
    // Thay tất cả các dấu câu thành 1 khoảng trắng
    let result = input.replace(/[.,:?!]/g, ' ');

    // Chuyển tất cả thành chữ viết thường
    if (isToLowerCase) result = result.toLowerCase();

    // Loại bỏ khoảng trắng đầu và cuối chuỗi
    result = result.trim();

    // Loại bỏ nhiều hơn 1 khoảng trắng liên tiếp
    result = result.replace(/\s+/g, ' ');

    return result;
}

// export function processString(text) {
//     // Kiểm tra đầu vào
//     if (!text || typeof text !== 'string') {
//         return '';
//     }

//     // Loại bỏ khoảng trắng đầu cuối và thay thế nhiều khoảng trắng liên tiếp bằng một khoảng trắng
//     let processedText = text.trim().replace(/\s+/g, ' ');

//     // Hàm bỏ dấu tiếng Việt
//     const removeAccents = (str) => {
//         return str
//             .normalize('NFD') // Phân tách ký tự thành ký tự cơ bản và dấu
//             .replace(/[\u0300-\u036f]/g, '') // Xóa các dấu
//             .replace(/đ/g, 'd') // Thay 'đ' thành 'd'
//             .replace(/Đ/g, 'D'); // Thay 'Đ' thành 'D'
//     };

//     // Chia thành các từ, bỏ dấu từng từ, chỉ giữ ký tự Latin và khoảng trắng
//     const words = processedText.split(' ').map((word) => {
//         // Bỏ dấu
//         let noAccents = removeAccents(word);
//         // Chỉ giữ ký tự Latin (a-z, A-Z)
//         return noAccents.replace(/[^a-zA-Z]/g, '');
//     });

//     // Lọc bỏ từ rỗng (nếu có) và nối lại bằng khoảng trắng
//     return words
//         .filter((word) => word.length > 0)
//         .join(' ')
//         .toLowerCase();
// }

export function processStringToKey(text) {
    // Kiểm tra đầu vào
    if (!text || typeof text !== 'string') {
        return '';
    }

    // Loại bỏ khoảng trắng đầu cuối và thay thế nhiều khoảng trắng liên tiếp bằng một khoảng trắng
    let processedText = text.trim().replace(/\s+/g, ' ');

    // Hàm bỏ dấu tiếng Việt
    const removeAccents = (str) => {
        return str
            .normalize('NFD') // Phân tách ký tự thành ký tự cơ bản và dấu
            .replace(/[\u0300-\u036f]/g, '') // Xóa các dấu
            .replace(/đ/g, 'd') // Thay 'đ' thành 'd'
            .replace(/Đ/g, 'D'); // Thay 'Đ' thành 'D'
    };

    // Chia thành các từ, bỏ dấu từng từ, chỉ giữ ký tự Latin và khoảng trắng
    const words = processedText.split(' ').map((word) => {
        // Bỏ dấu
        let noAccents = removeAccents(word);
        // Chỉ giữ ký tự Latin (a-z, A-Z)
        return noAccents.replace(/[^a-zA-Z]/g, '');
    });

    // Lọc bỏ từ rỗng (nếu có) và nối lại bằng khoảng trắng
    return words
        .filter((word) => word.length > 0)
        .join('_')
        .toLowerCase();
}

export function processStringToKeyList(text) {
    // Kiểm tra đầu vào
    if (!text || typeof text !== "string") {
        return "";
    }

    // Loại bỏ khoảng trắng đầu cuối và thay thế nhiều khoảng trắng liên tiếp bằng một khoảng trắng
    let processedText = text.trim().replace(/\s+/g, " ");

    // Hàm bỏ dấu tiếng Việt
    const removeAccents = (str) => {
        return str
            .normalize("NFD") // Phân tách ký tự thành ký tự cơ bản và dấu
            .replace(/[\u0300-\u036f]/g, "") // Xóa các dấu
            .replace(/đ/g, "d") // Thay 'đ' thành 'd'
            .replace(/Đ/g, "D"); // Thay 'Đ' thành 'D'
    };

    // Chia thành các từ, bỏ dấu từng từ, chỉ giữ ký tự Latin và khoảng trắng
    const words = processedText.toLowerCase().split(" ").map((word) => {
        // Bỏ dấu
        let noAccents = removeAccents(word);
        // Chỉ giữ ký tự Latin (a-z, A-Z)
        return noAccents.replace(/[^a-zA-Z]/g, "");
    });
    // Lọc bỏ từ rỗng (nếu có) và nối lại bằng khoảng trắng
    return words
        .filter((word) => word.length > 0)
}

export function getTypeOfResult(kq) {
    return kq.count === kq.correct ? 'right' : 'wrong';
}

export function getMaxLengthStringOfArray(item) {
    if (typeof item === 'string') {
        return item.length;
    } else if (Array.isArray(item)) {
        let max = 0;
        item.forEach((ele) => {
            if (ele.length > max) max = ele.length;
        });
        return max;
    } else {
        return 0;
    }
}

export function checkAnswer(string1, string2) {
    return processString(string1, true) === processString(string2, true);
}

export function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

const slightVibrate = [100, 50, 100];
const strongVibrate = [300, 50, 300];
export const handleVibrate = (vibration) => {
    const vibrationLevel =
        vibration === 'strong' ? strongVibrate : slightVibrate;
    // Kiểm tra xem thiết bị có hỗ trợ API Vibration không
    if (navigator.vibrate) {
        navigator.vibrate(vibrationLevel);
    } else {
        // alert('Thiết bị của bạn không hỗ trợ hiệu ứng rung.');
    }
};

export function countOccurrences(substring, string) {
    let count = 0;
    let pos = string.indexOf(substring);

    while (pos !== -1) {
        count++;
        pos = string.indexOf(substring, pos + 1);
    }

    return count;
}

export function countOccurrencesInArray(element, array) {
    return array.reduce((count, currentElement) => {
        return currentElement === element ? count + 1 : count;
    }, 0);
}

export const calcQuantityOfQuestion = (questions, util) => {
    let quantity = 0;
    for (let i = 0; i < questions.length; i++) {
        if (!isNaN(util) && i >= util) break;
        quantity += calcQuantityOfCurrentQuestion(questions[i]);
    }
    return quantity;
};

export const calcQuantityOfCurrentQuestion = (question) => {
    if (
        question.type === 'matching' ||
        question.type === 'matching-listening'
    ) {
        return question.pairs.length;
    } else if (question.type === 'multiple-choices' || question.type === 'multiple-choices-listening') {
        return 1;
    } else if (
        question.type === 'arrange' ||
        question.type === 'arrange-listening'
    ) {
        return 1;
    } else {
        return countOccurrences('______', question.content);
    }
};

export const compareArrayString = (arr1, arr2) => {
    if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;

    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
};
